import { render, staticRenderFns } from "./vistaEvaluacionDeudor.vue?vue&type=template&id=00bca772&scoped=true"
import script from "./vistaEvaluacionDeudor.vue?vue&type=script&lang=js"
export * from "./vistaEvaluacionDeudor.vue?vue&type=script&lang=js"
import style0 from "./vistaEvaluacionDeudor.vue?vue&type=style&index=0&id=00bca772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bca772",
  null
  
)

export default component.exports